import { render } from "./LoginForm.vue?vue&type=template&id=6bdd36b0&scoped=true&ts=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=6bdd36b0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bdd36b0"]])

export default __exports__